"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapKapiToSupplyPoint = exports.createSupplyPointInfo = exports.formatKapiRegisters = exports.translateKapiFuel = exports.mapStartDate = exports.mapDate = exports.isSupplyLive = exports.isObjectEmpty = exports.createOnboardingFlag = void 0;
var date_fns_1 = require("date-fns");
var utils_1 = require("../../../../domains/meter-reads/utils");
var __generated__1 = require("../../kapi/v1/__generated__/");
var ONBOARDING_DAYS = 6;
var INVALID_DATE_ERROR = 'Invalid date';
var createOnboardingFlag = function (supplyStartDate) {
    return (0, date_fns_1.isBefore)((0, date_fns_1.startOfToday)(), (0, date_fns_1.addDays)(new Date(supplyStartDate), ONBOARDING_DAYS));
};
exports.createOnboardingFlag = createOnboardingFlag;
var isObjectEmpty = function (obj) {
    return obj === null
        ? true
        : Object.values(obj).every(function (value) { return value === null || value === undefined; })
            ? true
            : false;
};
exports.isObjectEmpty = isObjectEmpty;
var isSupplyLive = function (data) {
    return !((0, exports.isObjectEmpty)(data.supplyPointInfo) ||
        data.mpxn === null ||
        data.isOnboarding);
};
exports.isSupplyLive = isSupplyLive;
var mapDate = function (date) {
    if (date) {
        var d = new Date(date);
        return d.toString() !== 'Invalid Date' ? d.toISOString() : null;
    }
    return null;
};
exports.mapDate = mapDate;
var mapStartDate = function (date) {
    var startDate = (0, exports.mapDate)(date);
    if (startDate === null) {
        throw new Error(INVALID_DATE_ERROR);
    }
    return startDate;
};
exports.mapStartDate = mapStartDate;
var translateKapiFuel = function (fuelType) {
    return fuelType === __generated__1.SupplyFuel.Electricity ? 'Electricity' : 'Gas';
};
exports.translateKapiFuel = translateKapiFuel;
var formatKapiRegisters = function (_a) {
    var registerId = _a.registerId, timePatternRegime = _a.timePatternRegime, timingCategory = _a.timingCategory;
    return ({
        meterRegisterId: registerId,
        timePatternRegime: timePatternRegime ? Number(timePatternRegime) : 0,
        timeOfUseLabel: timingCategory
            ? (0, utils_1.timingCategoryToTimeOfUseLabel)(timingCategory)
            : null,
        registerMappingCoefficient: '',
        clockingTimeId: 0,
        tier: null,
        switchedLoadIndicator: null,
        measurementQuantityId: null,
        meterRegisterMultiplier: null,
    });
};
exports.formatKapiRegisters = formatKapiRegisters;
var createSupplyPointInfo = function (address, region, meterTechnicalDetails, fuelType) {
    var hasMeterTechnicalDetails = (meterTechnicalDetails === null || meterTechnicalDetails === void 0 ? void 0 : meterTechnicalDetails.length) && meterTechnicalDetails[0];
    var hasRegisters = hasMeterTechnicalDetails &&
        meterTechnicalDetails[0].registers.length &&
        meterTechnicalDetails[0].registers[0];
    var kapiSupplyPointInfo = {
        address: (address === null || address === void 0 ? void 0 : address.addressLines) || null,
        postCode: (address === null || address === void 0 ? void 0 : address.postCode) || null,
        region: region || null,
        msn: hasMeterTechnicalDetails
            ? meterTechnicalDetails[0].meterSerialNumber
            : null,
        mapId: null,
        meterType: hasMeterTechnicalDetails ? meterTechnicalDetails[0].type : null,
        meterNoOfDigitsOrDials: hasRegisters &&
            meterTechnicalDetails[0].registers[0].numberOfDigits !== null &&
            meterTechnicalDetails[0].registers[0].numberOfDigits !== undefined
            ? parseInt(meterTechnicalDetails[0].registers[0].numberOfDigits, 10)
            : 0,
    };
    var registers = hasMeterTechnicalDetails && hasRegisters
        ? meterTechnicalDetails[0].registers.map(exports.formatKapiRegisters)
        : [];
    return (0, exports.isObjectEmpty)(kapiSupplyPointInfo)
        ? null
        : fuelType === __generated__1.SupplyFuel.Electricity
            ? __assign(__assign({}, kapiSupplyPointInfo), { registers: registers, lineLossFactorClassId: null }) : kapiSupplyPointInfo;
};
exports.createSupplyPointInfo = createSupplyPointInfo;
var mapGenericData = function (_a) {
    var startDate = _a.startDate, end = _a.end, _b = _a.supplyPoint, sprn = _b.sprn, address = _b.address, region = _b.region, fuelType = _b.fuelType, meterTechnicalDetails = _b.meterTechnicalDetails;
    return {
        start: (0, exports.mapStartDate)(startDate),
        end: (0, exports.mapDate)(end === null || end === void 0 ? void 0 : end.date),
        mpxn: sprn,
        fuel: (0, exports.translateKapiFuel)(fuelType),
        isOnboarding: (0, exports.createOnboardingFlag)(startDate),
        supplyPointInfo: (0, exports.createSupplyPointInfo)(address, region, meterTechnicalDetails, fuelType),
    };
};
var mapSupplyPoint = function (supplyPoint) {
    var genericSupplyPoint = mapGenericData(supplyPoint);
    return (0, exports.isSupplyLive)(genericSupplyPoint)
        ? genericSupplyPoint
        : genericSupplyPoint.fuel === 'Electricity'
            ? genericSupplyPoint
            : genericSupplyPoint;
};
var mapKapiToSupplyPoint = function (_a) {
    var account = _a.account;
    return account && account.accountSupplyPoints && account.accountSupplyPoints.length
        ? account.accountSupplyPoints.map(mapSupplyPoint)
        : [];
};
exports.mapKapiToSupplyPoint = mapKapiToSupplyPoint;
